import { ConversationInsightsFiltersV1Schema } from "@redotech/redo-model/conversation-filters/conversation-insights-filters";
import * as z from "zod/v4";

export const getConversationInsightsCount = {
  name: "getConversationInsightsCount" as const,
  input: z.object({ filters: ConversationInsightsFiltersV1Schema.optional() }),
  output: z.object({ count: z.int().min(0) }),
};
